import { DomainsApiClient } from '@wix/domains-serverless-interface/react-kit';
import { getPremiumEssentials } from '@wix/premium-fed-sdk/@premium-essentials';
import { fetchWithFallback } from '@wix/premium-fed-sdk/@apis-infra';

/** Pure Entri eligibility read — no modal, no manufacture, no flow-BI. */

export const resolveEntriEligibility = async _ref => {
  var _await$fetchWithFallb;
  let domain = _ref.domain,
    disablePointing = _ref.disablePointing,
    enabledBySpec = _ref.enabledBySpec;
  const _getPremiumEssentials = getPremiumEssentials(),
    httpClient = _getPremiumEssentials.httpClient;
  const _DomainsApiClient$que = DomainsApiClient.queries({
      httpClient: httpClient
    }),
    entriConfig = _DomainsApiClient$que.entriConfig,
    experiments = _DomainsApiClient$que.experiments;
  const entriConfigResponse = await entriConfig({
    disablePointing,
    domain
  });
  const checkDomainData = entriConfigResponse.checkDomainData,
    config = entriConfigResponse.config,
    isEligible = entriConfigResponse.isEligible;
  const isSpecEnabled = enabledBySpec && isEligible ? (_await$fetchWithFallb = (await fetchWithFallback(experiments({
    experiments: [enabledBySpec]
  }), {})).experiments) == null ? void 0 : _await$fetchWithFallb[enabledBySpec] : true;
  return {
    isEligible: !!isEligible,
    isSpecEnabled: !!isSpecEnabled,
    config,
    checkDomainData,
    entriConfigResponse
  };
};
//# sourceMappingURL=resolveEntriEligibility.js.map